// extracted by mini-css-extract-plugin
export default {"title":"delete_title__zdzvA","buttonPart":"delete_buttonPart__T2kOT","buttonCancel":"delete_buttonCancel__UGG-V","buttonDelete":"delete_buttonDelete__pJBi8"};